<template>

    <li class="task" v-bind:class="{'info-element': task.billable == 0, 'success-element': task.billable == 1}" id="task1" style="min-height:75px" v-bind:data-task-id="task.id" v-drop="drop">
        <div class="float-right">
            
            <form class="form-inline" v-show="edit">
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control task-estimate" style="width:24px;height:22px;padding-left:2px;font-size:12px;" v-model="task.estimate" @keyup.enter="saveTask">
                            <span class="input-group-addon" style="padding: 4px 8px;font-size:12px;">hr</span>
                            
                    </div>
                    <span><i class="fa fa-check" style="color:green" @click="saveTask"></i></span>
                    
                </div>
            </form>
            <span v-show="!edit" @click="editTask">{{task.estimate}} hrs</span>
        </div>
        <div class="task-title" style="min-height:36px;">{{task.title}}</div>
            <div class="agile-detail">
                <span style="color:lightgrey"> > {{task.story.title}}</span>   
            </div>
        <div class="agile-footer" style="min-height:16px;">

            <span class="label label-primary float-right">{{task.story.project.label}}</span>
        </div>
    </li>
                            
</template>

<script>
/*require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/droppable');
require('jquery-ui/ui/widgets/sortable');*/

    module.exports = {
    	props: ['task'],
        data: function () {
            return {
               edit: false,
               drop: {}
            }
        },
        watch: {
        	'drop': function(val, oldVal) {
        		var that = this;

        		this.task.due = val.date;
        		this.task.owner_id = val.resource_id;

        		/**
        		* When this element is dropped into the calendar we will get notified of the resource and date
        		*/
        		client({path: '/tasks/'+this.task.id, entity: this.task, mehod: 'PUT'}).then(
						function(response) {
							

						}, function(response) {

						}
					)
        	}
        },
        
        mounted: function() {

        	

        	/**
    		* Attach drag to task objects
    		*/
    		
				// store data so the calendar knows to render an event upon drop
				$(this.$el).data('event', {
					title: $.trim(this.task.title), // use the element's text as the event title
					stick: true, // maintain when user navigates (see docs on the renderEvent method)
					backgroundColor: '#fff',
            		borderColor: 'grey',
            		textColor: 'grey',
            		id: this.task.id,
                    story: this.task.story.title,
                    project: this.task.story.project.label,
                    estimate: this.task.estimate
				});

				// make the event draggable using jQuery UI
				$(this.$el).draggable({
					zIndex: 999,
					revert: true,      // will cause the event to go back to its
					revertDuration: 0  //  original position after the drag
				});

        },
        methods: {
        	'editTask': function() {
        		this.edit = true;
        		$(this.$el).find('input.task-estimate').click(function () {
				   $(this).select();
				});
        	},
        	'saveTask': function() {
        		this.edit = false;
        	}
        }
    }
</script>